import { render, staticRenderFns } from "./MethodPaidBtns.vue?vue&type=template&id=8f084b5c&"
import script from "./MethodPaidBtns.vue?vue&type=script&lang=js&"
export * from "./MethodPaidBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports